<template>
  <section class="my-3 cart-items row">
    <div class="col-12 col-lg-8 order-1 order-lg-0">


      <QuickAdd v-if="$page.props.auth.user.role == 'mtd'" :isWholesale="isWholesale" :update="update"/>

      <card icon="fas fa-shopping-cart" :title="`You have ${cart_items.length} ${cart_items.length >1 ? 'items' : 'item'} in your cart`">
        <template v-for="(item, itemIndex) in cart_items" :key="item.id">
          <ProductRow :item="item" :sku="item.product.sku" :margin="`${itemIndex+1 === cart_items.length ? 'mb-0 pb-0 border-bottom-0' : 'mb-3'}`">
            <template v-slot:headerContent>
              <div class="col-4">
                <div class="badge badge-success pt-1 ml-2 mt-2 float-right" v-if="item.from_inventory">Item is on Truck</div>
                <div v-else class="badge badge-primary pt-1 ml-2 mt-2 float-right">Item Will Ship</div>
                <div v-if="!isWholesale && $page.props.auth.user.role == 'mtd' && !item.product.user_id">
                  <div @click="changeToInventory(item)" class="badge badge-secondary pt-1 ml-2 mt-2 float-right cursor-pointer" v-if="!item.from_inventory"><i class="fas fa-truck mr-1 fa-sm"></i>Change to From Truck</div>
                  <div @click="changeToShipping(item)" class="badge badge-secondary pt-1 ml-2 mt-2 float-right cursor-pointer" v-else><i class="fas fa-box mr-1 fa-sm"></i>Change to Shipping</div>
                </div>
              </div>
            </template>

            <CartItemPrice :item="item"
              :itemIndex="itemIndex"
              :isWholesale="isWholesale"
              @onUpdate="update" />

          </ProductRow>
        </template>
      </card>
    </div>

    <div class="col-12 col-lg-4">
      <card class="mb-3">
        <p class="mb-0"><strong>Subtotal:</strong> {{ formatDollars($page.props.cart_total) }}</p>
      
        <div class="mt-2">
          <jet-button class="btn-sm mr-3 my-1 m-w-100" icon="fas fa-times-circle" @click="clearCart">Clear Cart</jet-button>

          <jet-button v-if="isMtd() && !isWholesale" class="btn-sm m-w-100 my-1" :goesTo="route('mtd.cart.convert')" icon="fas fa-share">Copy Items to Wholesale Cart</jet-button>
        </div>
      </card>

      <slot></slot>

    </div>
  </section>
</template>

<script>
  import ProductRow from '@/Components/Shop/ProductRow'
  import QuickAdd from '@/Components/Shop/QuickAdd'
  import CartItemPrice from './CartItemPrice.vue';

  export default {
    components: {
      ProductRow,
      QuickAdd,
      CartItemPrice,
    },
    data() {
      return {
        itemForm: this.$inertia.form({
          order_future_date: null,
          item_id: null
        }),
        formUpdateQuantity: this.$inertia.form({
          item_id: null,
          qty: null
        }),
        formUpdateProduct: this.$inertia.form({
          order_future_date: null,
          cart_item_future_id: null,
          item_id: null
        }),
        formDeleteItem: this.$inertia.form({
          order_future_date: null,
          item_id: null
        }),
        minFutureDate: new Date(moment()),
        maxFutureDate: new Date(moment().add(8, 'month')),
      }
    },
    props: {
      cart_items: Array,
      users: Array,
      total: Number,
      cartSent: Boolean,
      isWholesale: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      update() {
        this.$inertia.reload();
      },
      clearCart() {
        this.$inertia.visit(route(this.isWholesale ? 'mtd.cart.clear' : 'cart.clear'));
      },
      changeToInventory(item) {
        if (item.from_inventory || this.formUpdateProduct.processing) return;

        this.formUpdateProduct.item_id = item.id;
        this.formUpdateProduct.post(this.route('mtd.cart.changeToInventory'), { 
          preserveScroll: true
        })
      },
      changeToShipping(item) {
        if (!item.from_inventory || this.formUpdateProduct.processing) return;

        this.formUpdateProduct.item_id = item.id;
        this.formUpdateProduct.post(this.route('mtd.cart.changeToShipping'), { 
          preserveScroll: true
        })
      }
    }
  }
</script>

<style>
  .discount-container.applied {
    margin-top: 21px;
  }

  @media (max-width: 992px) {
    .discount-container.applied {
      margin-top: 7.5px;
    }
  }
</style>
